// The TearDrop Assistant's adds (garageFarmServer routes/assistant.js): the
// pure bits shared by the AI activity page and the "added by AI" tags.
// Records the assistant added carry source: 'ai' and an ai stamp
// { at, request, actionId }; see garageFarmServer models/aiStamp.js.
import { formatWhen } from './briefings';

export const KIND_LABEL = {
  note: 'Note',
  todo: 'To-do',
  lead: 'Outreach lead',
  harvest: 'Harvest',
  sowing: 'Sowing',
  reminder: 'Reminder',
  order_draft: 'Draft order',
  invoice_draft: 'Draft invoice',
  newsletter_draft: 'Newsletter draft',
};

// Where each kind shows up in Farm OS, for the activity list.
export const WHERE = {
  note: { label: 'Tasks, Notes', to: '/task-manager' },
  todo: { label: 'Tasks', to: '/task-manager' },
  lead: { label: 'Marketing, Outreach', to: '/email-studio' },
  harvest: { label: 'Harvests', to: '/harvests' },
  sowing: { label: 'Trays', to: '/tray-manager' },
  reminder: { label: 'Tasks, Reminders', to: '/task-manager' },
  order_draft: { label: 'Sales, Draft orders', to: '/orders?tab=drafts' },
  invoice_draft: { label: 'Sales, Invoices', to: '/orders?tab=invoices' },
  newsletter_draft: { label: 'Marketing, saved templates', to: '/email-studio' },
};

export const STATUS = {
  pending:   { label: 'Waiting for a yes', tone: 'warn' },
  running:   { label: 'Saving', tone: 'warn' },
  done:      { label: 'Added', tone: 'ok' },
  undone:    { label: 'Undone' },
  cancelled: { label: 'Not wanted' },
  expired:   { label: 'Never confirmed' },
  failed:    { label: 'Failed', tone: 'bad' },
};

// The activity list's filters
export const FILTERS = [
  { key: 'added', label: 'Added', statuses: ['done'] },
  { key: 'undone', label: 'Undone', statuses: ['undone'] },
  { key: 'unconfirmed', label: 'Not confirmed', statuses: ['pending', 'running', 'cancelled', 'expired', 'failed'] },
  { key: 'all', label: 'Everything', statuses: null },
];

export function filterActions(actions, key) {
  const f = FILTERS.find(x => x.key === key) || FILTERS[0];
  return f.statuses ? (actions || []).filter(a => f.statuses.includes(a.status)) : (actions || []);
}

export const isAiRecord = (rec) => rec?.source === 'ai';

// The tag's tooltip: when it was added and what was asked for.
export function aiTitle(rec) {
  const when = formatWhen(rec?.ai?.at);
  const asked = String(rec?.ai?.request || '').trim();
  return `Added by the AI assistant${when ? ` on ${when}` : ''}${asked ? `. Asked: "${asked}"` : ''}. Undo it on the AI activity page.`;
}

// Why an undo didn't happen. 'changed': edited since, so Farm OS asks before
// undoing anyway. 'blocked': it has moved on (sent, contacted, moved) and stays.
export function undoProblem(err) {
  const data = err?.response?.data || {};
  if (err?.response?.status === 409 && (data.undo === 'changed' || data.undo === 'blocked')) {
    return { kind: data.undo, message: data.error };
  }
  return { kind: null, message: data.error || err?.message || 'Something went wrong' };
}

// 'tda_…' tokens for the Open WebUI tool, 'tdn_…' for the phone shortcut.
export const TOKEN_KINDS = {
  actions: {
    title: 'Open WebUI tool',
    what: 'Lets the TearDrop actions tool look things up and add things (each add confirmed with you first).',
    where: 'In Open WebUI: Workspace > Tools > TearDrop actions > the gear button, paste it into "token" and save.',
  },
  notes: {
    title: 'Phone shortcut',
    what: 'Only adds notes, straight away (they\'re your own words). For a Siri Shortcut such as "Farm note".',
    where: 'In the Shortcuts app: "Get contents of URL", method POST, the URL below, header Authorization = Bearer <token>, JSON body with a text field.',
  },
};
